import { useState } from "react";

const questions = [
  { q: "What is Matka?", options: ["A lottery-type betting game", "A cricket format", "A stock exchange system", "A casino machine"], ans: 0 },
  { q: "What does 'Satta' mean?", options: ["Betting", "Shopping", "Saving money", "Programming"], ans: 0 },
  { q: "Matka game is mainly based on?", options: ["Numbers", "Colors", "Cards", "Dice"], ans: 0 },
  { q: "How many digits are in a single number?", options: ["1 digit", "2 digits", "3 digits", "4 digits"], ans: 0 },
  { q: "What does 'Jodi' represent?", options: ["A pair of numbers", "Three numbers", "Four numbers", "One number"], ans: 0 },
  { q: "What is an 'Open Number'?", options: ["First result", "Last result", "Middle value", "Extra value"], ans: 0 },
  { q: "What is a 'Close Number'?", options: ["Second result", "First result", "Random value", "Extra value"], ans: 0 },
  { q: "How many numbers are in a panel?", options: ["3 numbers", "2 numbers", "1 number", "4 numbers"], ans: 0 },
  { q: "Total digits in a panel?", options: ["3 digits", "2 digits", "4 digits", "1 digit"], ans: 0 },
  { q: "What do players predict in Matka?", options: ["Numbers", "Names", "Cities", "Colors"], ans: 0 },
  { q: "Which is a valid Jodi example?", options: ["12", "1", "123", "9"], ans: 0 },
  { q: "What is the maximum value of a single digit?", options: ["9", "10", "8", "7"], ans: 0 },
  { q: "Matka is primarily what type of game?", options: ["Chance-based", "Skill-based", "Mixed", "Strategy-only"], ans: 0 },
  { q: "How are results generally determined?", options: ["Randomly", "Fixed always", "Manually decided", "Voting system"], ans: 0 },
  { q: "Open + Close together form?", options: ["Jodi", "Panel", "Single", "Nothing"], ans: 0 },
  { q: "Is there risk in Matka?", options: ["Yes", "No", "Very low", "No risk at all"], ans: 0 },
  { q: "Is Satta legal in India?", options: ["Mostly illegal", "Fully legal", "Always legal", "Free everywhere"], ans: 0 },
  { q: "Nature of the game is?", options: ["Uncertain", "Guaranteed", "Fixed", "Predictable"], ans: 0 },
  { q: "What is responsible gaming?", options: ["Playing within limits", "Playing excessively", "Daily heavy betting", "Spending all money"], ans: 0 },
  {
    q: "In Matka, how is a panel's single digit derived?",
    options: [
      "By summing all digits and taking the last digit",
      "By multiplying digits",
      "By selecting highest digit",
      "By random choice"
    ],
    ans: 0
  },
  {
    q: "If a panel is 248, what will be its single digit?",
    options: ["4", "2", "8", "14"],
    ans: 0
  },
  {
    q: "Which combination correctly forms a valid panel?",
    options: ["Any 3 digits (0-9)", "Only even numbers", "Only odd numbers", "Only repeated digits"],
    ans: 0
  },
  {
    q: "What is the probability nature of Matka results?",
    options: [
      "Purely random with no guaranteed outcome",
      "Fully predictable",
      "Based on previous results only",
      "Controlled manually always"
    ],
    ans: 0
  },
  {
    q: "Which factor primarily affects winning in Matka?",
    options: [
      "Luck and randomness",
      "Fixed formula",
      "Daily patterns only",
      "Guaranteed logic"
    ],
    ans: 0
  },
  {
    q: "If open = 4 and close = 7, what is the jodi?",
    options: ["47", "74", "11", "37"],
    ans: 0
  },
  {
    q: "Which of the following is NOT a valid single digit outcome?",
    options: ["10", "0", "5", "9"],
    ans: 0
  },
  {
    q: "In a fair system, past results affect future outcomes?",
    options: [
      "No, each result is independent",
      "Yes, always",
      "Only sometimes fixed",
      "Depends on user choice"
    ],
    ans: 0
  },
  {
    q: "What does a 'patti' refer to in Matka?",
    options: [
      "A group of three digits forming a panel",
      "A pair of digits",
      "A single digit",
      "A betting amount"
    ],
    ans: 0
  },
  {
    q: "Which strategy guarantees winning in Matka?",
    options: [
      "No strategy guarantees winning",
      "Following previous numbers",
      "Doubling bets",
      "Using fixed charts"
    ],
    ans: 0
  },
  {
    q: "Why is Matka considered high-risk?",
    options: [
      "Because outcomes are uncertain and random",
      "Because results are always fixed",
      "Because profits are guaranteed",
      "Because numbers repeat always"
    ],
    ans: 0
  }
];

function QuizComponent() {
  const [currentQ, setCurrentQ] = useState(0);
  const [score, setScore] = useState(0);
  const [selected, setSelected] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const handleNext = () => {
    if (selected === questions[currentQ].ans) {
      setScore(score + 1);
    }

    setSelected(null);

    if (currentQ + 1 < questions.length) {
      setCurrentQ(currentQ + 1);
    } else {
      setShowResult(true);
    }
  };

  if (showResult) {
    return (
      <div style={styles.container}>
        <h2>Quiz Completed 🎉</h2>
        <h3>Your Score: {score} / {questions.length}</h3>

        <button onClick={() => window.location.reload()} style={styles.button}>
          Restart Quiz
        </button>
      </div>
    );
  }

  return (
    <div style={styles.container}>
        <br/>
      <h2>Matka Quiz</h2>

      <div style={styles.card}>
        <h3>
          Q{currentQ + 1}. {questions[currentQ].q}
        </h3>

        {questions[currentQ].options.map((opt, i) => (
          <div
            key={i}
            onClick={() => setSelected(i)}
            style={{
              ...styles.option,
              backgroundColor: selected === i ? "#4CAF50" : "#f1f1f1",
              color: selected === i ? "#fff" : "#000"
            }}
          >
            {opt}
          </div>
        ))}

        <button
          onClick={handleNext}
          disabled={selected === null}
          style={styles.button}
        >
          {currentQ === questions.length - 1 ? "Finish" : "Next"}
        </button>
      </div>
<br/>
<br/>
<br/>
      <p>
        Question {currentQ + 1} of {questions.length}
      </p>
    </div>
  );
}

const styles = {
  container: {
    textAlign: "center",
    padding: "20px",
    fontFamily: "Arial"
  },
  card: {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
    maxWidth: "420px",
    margin: "auto"
  },
  option: {
    padding: "12px",
    margin: "10px 0",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s"
  },
  button: {
    marginTop: "15px",
    padding: "10px 20px",
    border: "none",
    borderRadius: "8px",
    background: "#007bff",
    color: "#fff",
    cursor: "pointer"
  }
};

export default QuizComponent;